<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Show from "./show";
import { mapGetters } from 'vuex';

export default {
  page: {
    title: "أستمارة قطع الاراضي",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Show},
  data() {
    return {
      title: "المسجلين في الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/"
        },
        {
          text: "قطع الاراضي - المنتسبين",
          active: true,
        }
      ],
      
      canShow: false,
      loadingContent: true
    };
  },
  computed:{
    ...mapGetters('auth', ['getUser']),
  },
  created(){
    this.canShow = this.getUser.hasAnyPermission([
      "show_plotsofland",
      "show_details_plotsofland",
    ]);
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">

      <div class="col-md-12">
        <div class="card">

          <div class="card-body">
            <Show v-if="canShow" />
          </div>

        </div>
      </div>
                    
    </div>
    
  </Layout>
</template>